<template>
    <div class="product-list">
        <SubNav v-bind:active="0"></SubNav>
		<div class="profile-img">
			<img :src="imgUrl" alt="">
		</div>
        <div class="list-width">
            <div class="search-bar">
                <Row :gutter="0" justify="center">
                    <Col span="1">
                        <i class="fa fa-search" aria-hidden="true"></i>
                    </Col>
                    <Col span="21">
						<input placeholder="输入您要搜索的产品" v-model="searchValue"/>
                    </Col>
                    <Col span="2">
						<button @click="search(0)" style="float: right;width: 64px; height: 32px;background-color: #E5001F; border: none; border-radius: 4px;color: white;outline: none;cursor: pointer">搜索</button>
                        <!--<Button type="error" long >搜索</Button>-->
                    </Col>
                </Row>
            </div>
            <div class="hot-word">
                <strong>搜索热词:&nbsp;&nbsp;</strong>
                <a v-for="(item, index) in words" @click="searchHot(item.word, 0)">
					{{item.word}}&nbsp;&nbsp;
				</a>
                <p v-show="result">
					约有<span class="red">{{total}}</span>种车型符合查询结果
                </p>
            </div>

			<div class="list">
				<Row :gutter="10" justify="center" v-for="(item, index) in productList" :key="index" class="product">
					<Col span="5">
						<img width="200" height="140" :src="item.thumbnail">
					</Col>
					<Col span="15" style="padding-left: 15px">
						<h2>
							{{item.name}}
						</h2>
						<p>
							{{item.createtime}}
						</p>
						<h4>
							{{item.labelnames.replace('、', ' ')}}
						</h4>
						<span>
							{{item.summary}}
						</span>
					</Col>
					<Col span="4" long style="text-align: right">
						<router-link :to="{name:'product-details', query: { product_id: item.id }}"><Button class="dark">查看详细内容</Button></router-link>
					</Col>
				</Row>
				<div class="page">
					<Page :total="total" :current="current_page" @on-change="changePage"  prev-text="上一页" next-text="下一页" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import SubNav from './SubNav.vue'
	import * as product from '@/controller/product'

    export default {
        name: "list",
        components: { SubNav },
        data() {
            return {
				productList:[],
				imgUrl: '',
				total: 0,
				current_page: 1,
                searchValue:'',
				words: '',
				result: false
            }
        },
		mounted() {
			this.showBanner()
			this.hotWords()

            if(this.$route.query.words) {
                this.searchValue = this.$route.query.words
                this.search(this.$route.query.words)
            }else {
                this.showList()
            }
		},
        methods: {
			//显示banner图
			showBanner() {
				product.fetchBanner()
					.then(result => {
						this.imgUrl = result.imgUrl.product
					})
			},
			//搜索
			search(isSearch) {
				if(isSearch == 0) {
					this.current_page = 1
				}
				this.showList()
			},
			searchHot(hot, isSearch) {
				if(isSearch == 0) {
					this.current_page = 1
				}
                this.searchValue = hot
				this.showList(hot)
			},
			//显示产品列表
			showList(hot) {
				let query = new Object()
				query.current_page = this.current_page

				if(this.searchValue != '') {
					query.msg = this.searchValue
					this.result = true
				}
				if(hot != undefined) {
					query.msg = hot
					this.result = true
				}

				product.fetchProductList(query)
					.then((result) => {
						this.productList = result.list.list
						this.total = result.list.item_count
					})
			},
			// 点击分页触发
			changePage(val) {
				this.current_page = val
				this.showList()
			},
			//热词
			hotWords() {
				product.fetchHotWords()
					.then(result => {
						this.words = result.list
					})
			}
        }
    }
</script>

<style scoped lang="stylus">
    .product-list
        .profile-img
            background-color white
            overflow hidden
            img
                width 100%
        .list-width
            width 1000px
            margin 0 auto
            padding 28px 0px
            .search-bar
                border 1px solid #ED4114
                margin 20px 0px
                padding 3px
                border-radius 4px
                i
                    color #DB1232
                    font-size 18px
                    margin-top 6px
                input
                    width 100%
                    height 32px
                    outline none
                    border none
            .hot-word
                font-size 14px
                text-align left
                margin 10px 0px
                p
                    font-size 10px
                    padding-top 10px
					.red
						color #DB1232
				a
					color gray
			.list
				text-align left
				width $width
				margin 0 auto
				.product
					display: flex
					box-sizing: border-box
					align-items: center
					padding 20px
					border-bottom 1px solid #E7E7E7
					.dark
						background-color #557791
						border-color #557791
						color white
				img
					display block
					height 120px
					background-color gray
				span
					color gray
					overflow: hidden
					text-overflow: ellipsis
					display: -webkit-box
					-webkit-line-clamp: 2
					-webkit-box-orient: vertical
					margin-top 12px
				.page
					text-align center
					padding-top 30px
</style>